/**
 * @desc 反馈---Modal弹窗
 * @author caoyx
 */
import React from 'react';
import { Modal, Input } from 'antd';

const { TextArea } = Input;

const FeedbackModal = props => {
    let data = '';
    const getData = e => {
        data = e.target.value;
        return data;
    };

    /**
     * 属性回调，关闭Modal
     */
    const handleCancel = () => {
        props.modalCallback();
    };

    const handleOk = () => {
        // console.log('data', data);
    };

    return (
        <Modal
            {...props}
            title="反馈"
            okText="提交"
            maskClosable={false}
            visible={props.isVisible}
            onOk={handleOk}
            onCancel={handleCancel}
        >
            <TextArea rows={4} placeholder="请输入您的反馈意见" onBlur={getData} />
        </Modal>
    );
};

export default FeedbackModal;



// WEBPACK FOOTER //
// ./src/components/financialPicture/common/companyInfo/FeedbackModal.jsx